import { UNAUTHORIZED_MODES } from '../constants/permissionMode.js';

/**
 * Filters menu sections by the viewer's permissions (pure). An item opts in with a
 * `permission` key. `check(key)` returns `{ allowed, mode }` (see `PermissionsProvider`).
 * Denied + `hide`: the item is removed, and so is a section left empty. Denied + `lock`: the
 * item is kept with `locked: true` for the menu to render disabled.
 *
 * @param {Array<{ id: string, items: Array<{ id: string, permission?: string }> }>} sections
 * @param {(key: string) => { allowed: boolean, mode: string }} check
 */
export const filterMenuByPermission = (sections, check) =>
  sections
    .map((section) => ({
      ...section,
      items: section.items.flatMap((item) => {
        if (!item.permission) return [item];
        const { allowed, mode } = check(item.permission);
        if (allowed) return [item];
        return mode === UNAUTHORIZED_MODES.LOCK ? [{ ...item, locked: true }] : [];
      }),
    }))
    .filter((section) => section.items.length > 0);
